/* eslint-disable indent */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import { Image, Text, View, StyleSheet } from "@react-pdf/renderer";
import { ArrayOfArrays } from "interfaces/ShareDesign/IShareDesign";

const styles = StyleSheet.create({
  productImageWrapper: {
    flexDirection: "row",
    margin: 10,
  },
  productImageItem: {
    flexGrow: 1,
    padding: 40,
  },
  standardImage: {
    width: "100%",
  },
  productText: {
    alignSelf: "center",
    fontSize: "12px",
    fontWeight: "bold",
    marginTop: 20,
    wordWrap: "break-word",
    overflowWrap: "break-word",
    maxWidth: "250px",
  },
  designIdColor: {
    color: "red",
  },
});

const ProductImage = ({ productImages, pdfImgUrl, isMobile }: any) => {
  const [imgUrl, setImgUrl] = useState<ArrayOfArrays>([]);

  useEffect(() => {
    if (pdfImgUrl !== undefined && pdfImgUrl.length !== 0) {
      setImgUrl([...pdfImgUrl]);
    }
  }, [productImages, pdfImgUrl, isMobile]);

  return (
    <>
      {productImages
        ? productImages.map((item: any, key: number) => (
            <View key={`container${key}`} style={styles.productImageWrapper}>
              {item &&
                item.map((product: any, index: number) => (
                  <View key={`image${index}`} style={styles.productImageItem}>
                    {Array.isArray(imgUrl) && imgUrl?.length > 0 && (
                      <Image
                        src={
                          typeof imgUrl[key][index] === "object"
                            ? product.img
                            : `data:image/png;base64,${imgUrl[key][index]}`
                        }
                        style={styles.standardImage}
                      />
                    )}
                    <Text style={styles.productText}>
                      {product?.configurationName} (
                      <Text style={styles.designIdColor}>{product?.designId}</Text>)
                    </Text>
                  </View>
                ))}
            </View>
          ))
        : null}
    </>
  );
};

export default ProductImage;
